import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'lodash';
import { empty, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ISubscription } from 'rxjs/Subscription';
import { getGrouping } from '../../../store/selectors/previous-states-selectors';
import { unsubscribeComponent } from '../../helpers/unsubscribe-decorator/unsubscribe-decorators.helper';
import { IListSummaryModalEventObj } from '../../modals/list-summary/list-summary-modal.component';
import { ModalsService } from '../../modals/modals.service';
import { ListSummaryGroupings } from '../../services/list-summary-groupings/list-summary-groupings.service';

export interface IListSummaryTable {
  name: string;
  count: number;
}

@Component({
  selector: 'list-summary',
  template: require('./list-summary.component.html'),
  styles: [require('./list-summary.component.scss')],
})
@unsubscribeComponent
export class ListSummaryComponent implements OnInit {
  public summaryTable: {
    data: IListSummaryTable[];
    groupHumanName: string;
  } = { data: undefined, groupHumanName: undefined };
  public currentGrouping$: Observable<any>;
  public summaryTableRestricted: IListSummaryTable[];
  public sectionSubscription: ISubscription;
  public groupHumanNameSubscription: ISubscription;
  public groupName: string;
  public showMore: boolean;

  constructor(
    public modalsService: ModalsService,
    private store: Store<any>,
    private listSummaryGroupings: ListSummaryGroupings,
  ) {
    //
  }

  ngOnInit(): void {
    this.currentGrouping$ = this.store.select(getGrouping);

    const sections$ = this.currentGrouping$.pipe(
      switchMap(currentGroup => {
        let section = null;
        if (currentGroup) {
          // accomodate the old lists
          if (currentGroup.grouping.sections) {
            section = currentGroup.grouping.sections;
            this.summaryTable.data = section.filter(val => val.count > 0);
          } else {
            // assume we are in a new list
            section = currentGroup.grouping;
            this.summaryTable.data = currentGroup.grouping.filter(val => val.rowData.length > 0);
          }
          this.summaryTableRestricted = take(this.summaryTable.data, 5);
          this.showMore = this.summaryTable.data.length > 5 ? true : false;
        }
        return of(section);
      }),
    );
    this.sectionSubscription = sections$.subscribe();

    // get human readable group name
    const groupHumanName$ = this.currentGrouping$.pipe(
      switchMap(currentGroup => (currentGroup ? (this.groupName = currentGroup.groupHumanName) : empty())),
    );
    this.groupHumanNameSubscription = groupHumanName$.subscribe();
  }

  openModal(): void {
    this.summaryTable.groupHumanName = this.groupName;
    this.modalsService
      .openListSummaryModal(this.summaryTable)
      .afterClosed()
      .subscribe(($event: IListSummaryModalEventObj | undefined) => {
        if ($event) {
          this.listSummaryGroupings.groupingNavEvent$.emit($event);
        }
      });
  }

  onRowClick($sectionIndex: number): void {
    const $event: IListSummaryModalEventObj = { sectionIndex: $sectionIndex };
    this.listSummaryGroupings.groupingNavEvent$.emit($event);
  }
}
